import { i18n } from "translations";
import { getMapObjectFromArray } from "utils";

import { EmployeeIDCardType } from "./types";

export const EmployeeIDCardTypeOptions = [
  {
    label: i18n.t("citizenIdentityCard"),
    value: EmployeeIDCardType.CitizenIDCard,
  },
  {
    label: i18n.t("drivingLicense"),
    value: EmployeeIDCardType.DriverLicense,
  },
  {
    label: i18n.t("passport"),
    value: EmployeeIDCardType.Passport,
  },
  {
    label: i18n.t("identityCard"),
    value: EmployeeIDCardType.IDCard,
  },
  {
    label: i18n.t("personalIdentificationNumber"),
    value: EmployeeIDCardType.PIN,
  },
];

export const EmployeeIDCardTypeMap = getMapObjectFromArray(
  EmployeeIDCardTypeOptions
);
